var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.innerValue,"multiple":"","filterable":"","placeholder":_vm.placeholder,"disabled":_vm.disabled || !_vm.canLoad,"loading":_vm.loading},on:{"input":_vm.onInput}},_vm._l((_vm.options),function(t){return _c('el-option',{key:t.Id,attrs:{"label":_vm.teacherOptionLabel(t),"value":t.Id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }